(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ourosa-announcement"] && !Shopify.designMode) return;
  try {
    (()=>{
    const initialize=scope=>scope.querySelectorAll('[data-or-announcement]').forEach(root=>{
      if(root.dataset.ready)return;
      const toggle=root.querySelector('[data-or-announcement-toggle]');
      toggle.addEventListener('click',()=>{
        const paused=root.dataset.paused!=='true';
        root.dataset.paused=String(paused);
        toggle.setAttribute('aria-pressed',String(paused));
        toggle.setAttribute('aria-label',paused?toggle.dataset.playLabel:toggle.dataset.pauseLabel);
      });
      toggle.hidden=false;
      root.dataset.ready='true';
    });
    initialize(document);
    document.addEventListener('shopify:section:load',event=>initialize(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["snakehalo-marquee"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialize = scope => {
    scope.querySelectorAll('[data-sh-marquee]').forEach(root => {
      if (root.dataset.shMarqueeReady) return;
      const button = root.querySelector('[data-sh-marquee-toggle]');
      if (!button) return;
      button.addEventListener('click', () => {
        const paused = root.dataset.shMarqueePaused !== 'true';
        root.dataset.shMarqueePaused = String(paused);
        button.setAttribute('aria-pressed', String(paused));
        button.setAttribute('aria-label', paused ? button.dataset.playLabel : button.dataset.pauseLabel);
      });
      button.hidden = false;
      root.dataset.shMarqueeReady = 'true';
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["snakehalo-motion"] && !Shopify.designMode) return;
  try {
    function initSnakehaloFilms(root){
  if(root.dataset.shFilmsReady)return;
  root.dataset.shFilmsReady='true';
  const labels=JSON.parse(root.querySelector('[data-sh-film-labels]').textContent);
  const motion=matchMedia('(prefers-reduced-motion: reduce)');
  const autoAllowed=()=>!motion.matches&&!navigator.connection?.saveData;
  const players=[...root.querySelectorAll('[data-sh-film]')].map(video=>({video,button:video.parentElement.querySelector('[data-sh-film-toggle]'),visible:false,manualPaused:false}));
  const load=player=>{const source=player.video.querySelector('source[data-src]');if(source){source.src=source.dataset.src;source.removeAttribute('data-src');player.video.load()}};
  function sync(player){const playing=!player.video.paused;player.button.setAttribute('aria-pressed',String(playing));player.button.querySelector('[data-sh-film-label]').textContent=playing?labels.pause:labels.play;player.button.querySelector('[data-sh-film-icon]').textContent=playing?'Ⅱ':'▶'}
  function play(player){load(player);player.video.play().then(()=>sync(player)).catch(()=>sync(player))}
  players.forEach(player=>{
    ['play','pause','error','ended'].forEach(event=>player.video.addEventListener(event,()=>sync(player)));
    player.button.addEventListener('click',()=>{if(player.video.paused){player.manualPaused=false;play(player)}else{player.manualPaused=true;player.video.pause()}});
  });
  if('IntersectionObserver'in window){
    const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{const player=players.find(item=>item.video===entry.target);player.visible=entry.isIntersecting;if(entry.isIntersecting&&autoAllowed()&&!player.manualPaused&&!document.hidden)play(player);else player.video.pause()}),{threshold:.55});
    players.forEach(player=>observer.observe(player.video));
  }
  document.addEventListener('visibilitychange',()=>players.forEach(player=>{if(document.hidden)player.video.pause();else if(player.visible&&autoAllowed()&&!player.manualPaused)play(player)}));
  motion.addEventListener('change',()=>{if(motion.matches)players.forEach(player=>player.video.pause())});
}
document.querySelectorAll('[data-sh-films]').forEach(initSnakehaloFilms);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-sh-films]').forEach(initSnakehaloFilms));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["snakehalo-reviews"] && !Shopify.designMode) return;
  try {
    function initSnakehaloReviews(root){
  if(root.dataset.shReviewsReady)return;
  root.dataset.shReviewsReady='true';
  const cards=[...root.querySelectorAll('[data-sh-review]')],filter=root.querySelector('[data-sh-review-filter]'),source=root.querySelector('[data-sh-review-source]'),more=root.querySelector('[data-sh-review-more]'),empty=root.querySelector('[data-sh-review-empty]'),bars=[...root.querySelectorAll('[data-sh-rating]')],pageSize=matchMedia('(max-width:640px)').matches?3:6;
  let limit=pageSize;
  function update(){const matching=cards.filter(card=>(filter.value==='all'||card.dataset.rating===filter.value)&&(!source||source.value==='all'||card.dataset.source===source.value));cards.forEach(card=>card.hidden=true);matching.slice(0,limit).forEach(card=>card.hidden=false);more.hidden=matching.length<=limit;empty.hidden=matching.length!==0;bars.forEach(bar=>bar.setAttribute('aria-pressed',String(bar.dataset.shRating===filter.value)))}
  [filter,source].filter(Boolean).forEach(select=>{select.disabled=false;select.addEventListener('change',()=>{limit=pageSize;update()})});
  bars.forEach(bar=>{bar.disabled=false;bar.addEventListener('click',()=>{filter.value=filter.value===bar.dataset.shRating?'all':bar.dataset.shRating;limit=pageSize;update()})});
  more.addEventListener('click',()=>{limit+=pageSize;update()});
  update();
}
document.querySelectorAll('[data-sh-reviews]').forEach(initSnakehaloReviews);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-sh-reviews]').forEach(initSnakehaloReviews));
  } catch(e) { console.error(e); }
})();

})();
